import { Theme } from "@remo-co/ui-core/src/types";

export const styles = {
  cfpContainer: {
    display: "flex",
    justifyContent: "start !important",
    alignItems: "start !important",
    gap: "40px",
  },
  colorPicker: {
    display: "flex",
    flexDirection: "column",
    justifyCenter: "unset !important",
    alignItems: "unset !important",
    marginBottom: "10px !important",
    maxWidth: "300px",
    "& label": {
      color: "text.primary",
      fontSize: "14px",
      fontWeight: "500",
      marginBottom: "4px",
    },
    "& div": {
      width: "272px",
    },
  },
  colorPickerInput: {
    display: "flex",
    gap: "20px",
    alignItems: "center",
    border: "1px solid",
    borderColor: "events.grayShade1",
    borderRadius: "5px",
    padding: "11.5px 13px",
    boxShadow: (theme: Theme) =>
      `4px 4px 4px 0px ${theme.palette.boxShadow.default}`,
    "& input": {
      width: "32px",
      height: "32px",
    },
  },
  tagsBox: {
    marginBottom: "10px",
    "& .MuiInputBase-root": {
      width: "300px",
    },
  },
  inputGroupButtons: {
    position: "relative",
    top: "420px",
    gap: "10px",
  },
  deleteBtn: {
    width: "40px",
  },
  input: {
    minWidth: "300px",
  },
  error: {
    border: "1px solid",
    borderColor: (theme: Theme) => `${theme.palette.error.main} !important`,
  },
  closeIcon: {
    color: "text.primary",
  },
  actionButtons: {
    "& .MuiButtonBase-root .MuiTypography-root": {
      padding: "0px 40px !important",
    },
  },
  content: {
    width: "486px",
  },
};
